/* eslint-disable jsx-a11y/anchor-is-valid */
import { Pie } from 'react-chartjs-2';
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import { useState } from 'react';
import ChartDataLabels from 'chartjs-plugin-datalabels';

export function Dashboard1(props: any) {
    const { dataSource } = props
    const data: any = {
        labels: dataSource.labels,
        datasets: [
            {
                label: dataSource.datasets[0].label,
                data: dataSource.raw_data,
                backgroundColor: [
                    '#36688d',
                    '#7A77FF',
                    '#F4C3D9',
                    '#FEBBBA',
                    '#F4874C',
                    '#F46A4E',
                ],
                borderWidth: 1,
            },
        ],
    }

    const options: any = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            title: {
                display: true,
                text: "จำนวนความถี่ของคำถาม 30 วันล่าสุด",
                font: {
                    size: 16
                }
            },
            legend: {
                display: false,
            },
            datalabels: {
                anchor: 'center',
                color: 'black',
                labels: {
                    title: {
                        font: {
                            weight: 'bold'
                        }
                    },
                    value: {
                        color: 'green'
                    }
                }
            }
        },
    };

    return (<Pie data={data} plugins={[ChartDataLabels]} options={options} width={350} height={350} />)

}